import { useState, useEffect } from 'react';
import { ICONS } from '../../constants/imageConstants';
import { cn } from '../../lib/utils';

const AuthAlerts = ({ message, type = 'error', onClear }) => {
  const [isVisible, setIsVisible] = useState(false);

  const alertStyles = {
    error: 'bg-red-50 text-red-600 border border-red-200', 
    success: 'bg-green-50 text-green-600 border border-green-200'
  };

  const iconSrc = {
    error: ICONS.ERROR,
    success: ICONS.SUCCESS
  };
  
  const closeIconSrc = {
    error: ICONS.ERR_CLOSE,
    success: ICONS.SUCCESS_CLOSE 
  };

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      
      if (type === 'error') {
        const timer = setTimeout(() => {
          setIsVisible(false);
          setTimeout(onClear, 300);
        }, 5000);
        return () => clearTimeout(timer);
      }
    } else {
      setIsVisible(false);
    }
  }, [message, type, onClear]);

  if (!message) return null;

  return (
    <div
      className={cn(
        'flex items-center justify-start rounded-lg p-3 w-full shadow-sm transition-all duration-300 ease-in-out',
        alertStyles[type],
        isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'
      )}
      role="alert"
    >
      <img src={iconSrc[type]} alt={type} className="flex-shrink-0 w-5 h-5" />
      <div className="flex-1 mx-3">
        <p className="text-sm font-medium leading-tight break-words">
          {message}
        </p>
      </div>
      <button
        onClick={() => {
          setIsVisible(false);
          setTimeout(onClear, 300);
        }}
        aria-label="Close alert"
        className="flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity p-1 flex items-center justify-center"
      >
        <img src={closeIconSrc[type]} alt="Close" className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AuthAlerts;